<script setup>
defineOptions({
  name: 'ProviderTripsPerTime',
})

const { t } = useI18n()
const { getColor } = useSharedChartColors()
</script>

<template>
  <MetricCard
    kpi="providerTripsPerTime"
    :used-filters="[
      'mode',
      'dateRange',
      'timeMode',
      'country',
      'region',
      'filterBySpecs',
    ]"
  >
    <template #title>
      {{ t('Trip evolution') }}
    </template>
    <template #subtitle>
      {{ t('Data from unlocked cities') }}
    </template>

    <template #default="{ data, dataUpdateId }">
      <BarMetric
        :data="data"
        :options="{
          dimension: DimensionTypes.LOCATION,
          afterTitle: 'sum',
          color: d => getColor(d.name, dataUpdateId),
        }"
        type="time"
      />
    </template>
  </MetricCard>
</template>
